module.exports = __webpack_public_path__ + "static/media/gardenwatch.6598efff.gif";